import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class AppClockService {
    readonly minuteInterval = new EventEmitter();

    start () {
        setInterval(() => {
            this.minuteInterval.emit();
        }, 60000);
    }
}
